import Head from 'next/head'
import Image from 'next/image'

import styles from '@/components/showroom/Showroom.module.scss'
import ParallaxContent from '@bww/beke-ui/ParallaxContent'

import { siteConfig } from '@bww/beke-lib/site-config'

import classNames from 'classnames'

export default function ShowroomPage() {
  return (
    <>
      <Head>
        <title>
          Large Bathroom Showroom in the Nuffield Trade Centre, Poole
        </title>
        <meta
          name="description"
          content="More than 50 fitted bathroom displays to browse in our 4000 square foot showroom within the Poole Nuffield Industrial Estate (next to the Smyths toy store)."
        />
      </Head>

      <header className={classNames(styles.header, 'container')}>
        <h1 className="h1">
          <span style={{ fontSize: '.8em' }}>Bathroom Elegance</span>
          <br />
          <strong>Poole Showroom</strong>
        </h1>
      </header>

      <div className="container">
        <figure className={styles.imageWrapper}>
          <ParallaxContent
            offset={100}
            parallaxEl={
              <Image
                priority
                fill
                style={{ objectFit: 'cover', objectPosition: '10% 40%' }}
                src="https://cdn.sanity.io/images/ly18yecr/production/20983184503875c74423217e8a18986616060262-2560x1976.jpg"
                alt="Bathroom Elegance showroom in Poole"
              />
            }
          >
            <div className={styles.headingContainer}>
              <figcaption className="h3 match">
                <strong>50 bathroom displays,</strong>
                <br />
                <strong>4,000 square feet to browse</strong>
              </figcaption>
            </div>
          </ParallaxContent>
        </figure>

        <section className={styles.locationInfo}>
          <div className={styles.addressContainer}>
            <span>{siteConfig.address.address1}</span>
            <span>{siteConfig.address.address2}</span>
            <span>
              {siteConfig.address.locality}&ensp;{siteConfig.address.postCode}
            </span>
          </div>
          <a className="button button--small" href={siteConfig.googlePlaceUrl}>
            Directions
          </a>
        </section>

        <section>
          <div className={styles.displayImageWrapper}>
            <Image
              fill
              src="https://cdn.sanity.io/images/ly18yecr/production/32ced8a02d77d4e40c4ddb1ac8abd6cb13e3f57e-3942x2956.jpg"
              style={{ objectFit: 'cover' }}
              alt="Bathroom Elegance showroom bathroom"
            />
          </div>
          <div className={styles.displayImageWrapper}>
            <Image
              fill
              src="https://cdn.sanity.io/images/ly18yecr/production/865d85b46e984b81e2a3b24ca22be478eda9e77f-3910x2932.jpg"
              style={{ objectFit: 'cover' }}
              alt="Bathroom Elegance showroom bathroom"
            />
          </div>
          <div className={styles.displayImageWrapper}>
            <Image
              fill
              src="https://cdn.sanity.io/images/ly18yecr/production/817426ee6f3d43823965b105d2a8e1fd4502bfe6-3306x2482.jpg"
              style={{ objectFit: 'cover' }}
              alt="Bathroom Elegance showroom bathroom"
            />
          </div>
          <div className={styles.displayImageWrapper}>
            <Image
              fill
              src="https://cdn.sanity.io/images/ly18yecr/production/0ef90dccee875b16c22aa6200412364464923340-4032x3024.jpg"
              style={{ objectFit: 'cover' }}
              alt="Bathroom Elegance showroom bathroom"
            />
          </div>
          <div className={styles.displayImageWrapper}>
            <Image
              fill
              src="https://cdn.sanity.io/images/ly18yecr/production/ff8e04175cc3ea8f3b69e21f8be685fe40b02ea0-3578x2872.jpg"
              style={{ objectFit: 'cover' }}
              alt="Bathroom Elegance showroom bathroom"
            />
          </div>
        </section>
      </div>
    </>
  )
}
